import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import CompassLogo from './logos/compass.svg'
import DoordashLogo from './logos/doordash.svg'
import GongLogo from './logos/gong.svg'
import IndianaUniversityLogo from './logos/indiana-university.svg'
import LorealLogo from './logos/loreal.svg'
import LyftLogo from './logos/lyft.svg'
import ZendeskLogo from './logos/zendesk.svg'
import _LogosContainer from "social_proof-LogosContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/social_proof.js?styleId=LogosContainer";


const customerLogos = [
  'DoorDash',
  'Gong',
  'Indiana University',
  'Lyft',
  'Compass',
  'Loreal',
  'Zendesk'
]

const logoSources = {
  DoorDash: DoordashLogo,
  Gong: GongLogo,
  'Indiana University': IndianaUniversityLogo,
  Lyft: LyftLogo,
  Compass: CompassLogo,
  Loreal: LorealLogo,
  Zendesk: ZendeskLogo
}

const LogosContainer = /*#__PURE__*/styled('div', null, {
  displayName: "LogosContainer",
  styles: _LogosContainer,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isPhone: useDeviceType('isPhone')
  })
})

export const SocialProof = () => (
  <LogosContainer>
    {customerLogos.map((logoName) => (
      <img
        className="img"
        key={logoName}
        src={logoSources[logoName]}
        alt={logoName}
        name={logoName}
      />
    ))}
  </LogosContainer>
)
